/*
 * Copyright (C) 2019 Toshiba Corporation
 * SPDX-License-Identifier: Apache-2.0
 */

import { DThemeWhiteMenuItemExpandableItemLink } from "./d-theme-white-menu-item-expandable-item-link";

export class DThemeWhiteMenuSidedItemExpandableItemLink extends DThemeWhiteMenuItemExpandableItemLink {}
